package com.iregained.site.components.sections.about.sections

import androidx.compose.runtime.*
import com.iregained.site.components.sections.about.styles.AboutCtaButtonStyle
import com.iregained.site.components.widgets.SharedCtaActionLink
import com.iregained.site.components.widgets.SharedCtaWidget
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div

// UNIQUE ANIMATION: Focus Pull
@Composable
private fun Modifier.focusPull(isVisible: Boolean): Modifier {
    return this.opacity(if (isVisible) 1 else 0).scale(if (isVisible) 1f else 0.95f).transition(
            Transition.of("opacity", 0.9.s, TransitionTimingFunction.EaseOut),
            Transition.of("transform", 0.9.s, TransitionTimingFunction.EaseOut)
        )
}

@Composable
fun AboutCtaSection(data: AboutCtaData = defaultAboutCtaData) {
    val targetId = data.sectionId?.takeIf { it.isNotBlank() } ?: "about-cta-section"
    var isVisible by remember { mutableStateOf(false) }

    if (data.headline.isNotBlank()) {
        Div(attrs = Modifier.fillMaxWidth().toAttrs {
            ref { element ->
                val observer = IntersectionObserver { entries, obs ->
                    entries.forEach {
                        if (it.isIntersecting) {
                            isVisible = true; obs.unobserve(element)
                        }
                    }
                }
                observer.observe(element); onDispose { observer.disconnect() }
            }
        }) {
            Box(modifier = Modifier.fillMaxWidth().focusPull(isVisible)) {
                SharedCtaWidget(headline = data.headline, description = data.description) {
                    SharedCtaActionLink(
                        text = data.buttonText,
                        path = data.buttonPath,
                        styleModifier = AboutCtaButtonStyle.toModifier()
                    )
                }
            }
        }
    }
}

// ==========================================
// CMS DATA MODEL: CTA
// ==========================================
data class AboutCtaData(
    val sectionId: String? = null,
    val headline: String = "Join Our Mission to Transform Recovery.",
    val description: String = "Whether you are a healthcare provider, researcher, or potential partner, discover how IRegained is redefining stroke rehabilitation worldwide.",
    val buttonText: String = "Connect With Our Team",
    val buttonPath: String = "/contact" // Routes to your dynamic regional contact form
)

val defaultAboutCtaData = AboutCtaData()